module.exports = new __parcel__URL__("water_cooler_cosmetic_icon.40e94d9f.png").toString();